import axios from 'axios';

export const getPricingSheets = (params, callback) => {
    let config = {
        params,
        url: `/pricing_sheets`,
        errorMessage: 'Something went wrong while loading Pricing Sheets',
    };
    axios.request(config).then(result => callback(result.data));
};


// WEBPACK FOOTER //
// ./src/containers/embeddable/pricing_sheet/PricingSheetApi.js